import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useParams, useLocation, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Playground from './components/Playground';
import GettingStarted from './components/GettingStarted';
import Ecosystem from './components/Ecosystem';
import Achievements from './components/Achievements';
import Explore from './components/Explore';
import Glossary from './components/Glossary';
import Footer from './components/Footer';
import ConceptOverview from './components/ConceptOverview';
import ConceptExplainer from './components/ConceptExplainer';
import { WalletProvider } from './contexts/WalletContext';
import { MidenExecutionProvider } from './contexts/MidenExecutionContext';
import { ProgressProvider } from './contexts/ProgressContext';
import { NotificationProvider} from './contexts/NotificationContext';
import { DevModeProvider } from './contexts/DevModeContext';
import { ToastContainer } from './components/Toast';
import ConfirmModal from './components/ConfirmModal';
import './App.css';

// Home Page Component
function HomePage() {
  return (
    <div className="container">
      <Hero />
      <ConceptOverview />
      <GettingStarted />
      <Footer />
    </div>
  );
}

// Concept Explainer Route Component
function ConceptExplainerPage() {
  const { conceptId } = useParams();
  const navigate = useNavigate();
  
  return (
    <ConceptExplainer 
      conceptId={conceptId} 
      onBack={() => navigate('/')} 
    />
  );
}

// Playground Page Component
function PlaygroundPage() {
  const [playgroundResetKey, setPlaygroundResetKey] = useState(0);
  const location = useLocation();
  
  // Reset playground when navigating to it (e.g., clicking the nav link again)
  React.useEffect(() => {
    setPlaygroundResetKey(prev => prev + 1);
  }, [location.key]);
  
  return (
    <>
      <Playground 
        key={playgroundResetKey} 
        isPlaygroundPage={true} 
      />
      <Footer />
    </>
  );
}

// Generic Page Wrapper
function PageWithFooter({ children }) {
  return (
    <div className="container">
      {children}
      <Footer />
    </div>
  );
}

function AppContent() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation();
  
  // Determine current page from location
  const currentPage = location.pathname === '/' ? 'home' : location.pathname.slice(1).split('/')[0];

  return (
    <div className="App">
      <div className="edge-scroll">
        <Header 
          currentPage={currentPage} 
          isSidebarCollapsed={isSidebarCollapsed}
          setIsSidebarCollapsed={setIsSidebarCollapsed}
        />
        <div className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/playground" element={<PlaygroundPage />} />
            <Route path="/explore" element={<PageWithFooter><Explore /></PageWithFooter>} />
            <Route path="/achievements" element={<PageWithFooter><Achievements /></PageWithFooter>} />
            <Route path="/glossary" element={<PageWithFooter><Glossary /></PageWithFooter>} />
            <Route path="/ecosystem" element={<PageWithFooter><Ecosystem /></PageWithFooter>} />
            <Route path="/concept/:conceptId" element={<ConceptExplainerPage />} />
          </Routes>
        </div>
      </div>
      <ToastContainer />
      <ConfirmModal />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <NotificationProvider>
        <WalletProvider>
          <MidenExecutionProvider>
            <ProgressProvider>
              <DevModeProvider>
                <AppContent />
              </DevModeProvider>
            </ProgressProvider>
          </MidenExecutionProvider>
        </WalletProvider>
      </NotificationProvider>
    </BrowserRouter>
  );
}

export default App;